module.exports = (post, collection) => {
    return `/${collection}/${post.slug}`
}